module.exports = __webpack_public_path__ + "static/img/vacation-capsule-wardrobe-for-men.42c8dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/vacation-capsule-wardrobe-for-men.jpg
// module id = FQ4r
// module chunks = 0